import React, { FC } from 'react'
import LoadingSpinner from './loading_spinner'

interface AiLoadingOverlayProps {
  message: string
  isVisible: boolean
  description?: string
}

/**
 * AI生成中の全画面オーバーレイコンポーネント
 * メッセージと説明文を表示し、画面操作をブロックする
 */
const AiLoadingOverlay: FC<AiLoadingOverlayProps> = ({
  message,
  description,
  isVisible,
}) => {
  if (!isVisible) return null

  return (
    <div className="fixed inset-0 bg-black bg-opacity-55 z-50 flex flex-col justify-center items-center py-20">
      <LoadingSpinner />
      <div className="mt-6 text-white text-center">
        <p className="text-lg mb-2">画面を閉じずにお待ちください</p>
        {description && <p>{description}</p>}
      </div>
      <div className="mt-10 flex justify-center">
        {message.split('').map((char, index) => (
          <span
            key={index}
            className="inline-block animate-bounce text-white text-3xl font-bold"
            style={{
              animationDelay: `${index * 0.15}s`,
              animationDuration: '2s',
              animationIterationCount: 'infinite',
            }}
          >
            {char === ' ' ? '\u00A0' : char}
          </span>
        ))}
      </div>
    </div>
  )
}

export default AiLoadingOverlay
